import { useTranslations } from "@jti/ui/providers/useTranslations";

import styles from "../../../SticksForm.module.scss";

type QuantityGroupTitleProps = {
  step: number;
};

export const QuantityGroupTitle = ({ step }: QuantityGroupTitleProps) => {
  const { __ } = useTranslations();

  return (
    <>
      <strong className={styles.stepCountLabel}>{__(`sticksForm.step.order_text.${step}`)}</strong>{" "}
      {__("sticksForm.step.quantity_selection.title")}
    </>
  );
};
